import { render, staticRenderFns } from "./CardVerticalItem.vue?vue&type=template&id=58f2b74a"
import script from "./CardVerticalItem.vue?vue&type=script&lang=js"
export * from "./CardVerticalItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports